import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

// On-brand shell for the per-app legal pages (privacy / terms / support).
// Pages pass their heading metadata + content; the dark redesign theme is
// forced via .r-root so they match the homepage regardless of app theme.
const LegalLayout = ({ app, docType, icon: Icon, accent = '#d100a3', lastUpdated, children }) => (
  <div className="r-root legal-page">
    <div className="r-page-bg" aria-hidden="true" />
    <div className="r-wrap legal-wrap">
      <Link to="/apps" className="legal-back">
        <ArrowLeft className="w-4 h-4" />
        Back to Apps
      </Link>

      <header className="legal-header">
        {Icon && (
          <div className="legal-icon" style={{ background: `${accent}1f`, color: accent }}>
            <Icon className="w-7 h-7" />
          </div>
        )}
        <div className="legal-eyebrow" style={{ color: accent }}>{app}</div>
        <h1 className="legal-title">{docType}</h1>
        {lastUpdated && <p className="legal-updated">Last updated: {lastUpdated}</p>}
      </header>

      <div className="legal-prose">{children}</div>
    </div>
  </div>
);

export default LegalLayout;
